// extracted by mini-css-extract-plugin
export default {"row":"BoardListViewItem_row__+PzLg","col":"BoardListViewItem_col__AIKOO","button":"BoardListViewItem_button__s7cs0"};